import React, {Component} from 'react';
// import _ from 'lodash';
import {connect} from 'react-redux';
// import dump from '../../img/1440x600/1440x600.jpg';
import Slider from 'react-slick';
// import ProductCard from '../product/ProductCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class MultiCarousel extends Component {

    render() {
        const {slideToShow, slidesToScroll, infinite, responsiveSetting, arrow, customPaging, dots} = this.props; //items, type, 
        const displayArrow = (typeof arrow !== "undefined" && arrow !== null)? arrow: true;
        let settings = {
            dots: typeof dots !== "undefined"? dots : true,
            infinite: typeof infinite !== "undefined"? infinite: false,
            speed: 500,
            slidesToShow: typeof slideToShow !== "undefined"? slideToShow: 4,
            slidesToScroll: typeof slidesToScroll !== "undefined"? slidesToScroll: 1,
            arrows: displayArrow,
            nextArrow: <NextArrow display={displayArrow} />,
            prevArrow: <PrevArrow display={displayArrow} />,
            initialSlide: 0,
            variableWidth: false,
        };
        if (customPaging) {
            settings.customPaging = customPaging;
        }
        return (
            <Slider {...settings}
                responsive={(typeof responsiveSetting !== "undefined" && responsiveSetting !== null)
                    ? responsiveSetting
                    : [{breakpoint: 576, settings: {slidesToShow: 1, slidesToScroll: 1, initialSlide: 0}}, {breakpoint: 767, settings: {slidesToShow: 1, slidesToScroll: 1, initialSlide: 0}}]
                }
            >
                {this.props.children}
            </Slider>
        );
    }
}

function NextArrow(props) {
    const {onClick, display} = props
    return (
        // <div
        //     className={className}
        //     style={{...style, display: 'block'}}
        //     onClick={onClick}
        // ><i className="fal angle-right" /></div>
        <div className="slick-arrow slick-right" style={{display: display? 'block': 'none'}} onClick={onClick}><FontAwesomeIcon icon={["fal", "chevron-right"]}/></div>
    );
}

function PrevArrow(props) {
    const {onClick, display} = props; //style, className
    return (
        // <div
        //     className={className}
        //     style={{...style, display: 'block'}}
        //     onClick={onClick}
        // ><i className="fal angle-left" /></div>
        <div className="slick-arrow slick-left" style={{display: display? 'block': 'none'}} onClick={onClick}><FontAwesomeIcon icon={["fal", "chevron-left"]}/></div>
    );
}


function mapStateToProps(state) {
    return {}
}
export default connect(mapStateToProps, {})(MultiCarousel)